export default "__VITE_ASSET__D$Rd9$o5__"